import * as React from "react";
import FlowChartWapImg from "@/assets/images/wx/img/flow-chart-wap.png";
import FlowChartPcImg from "@/assets/images/wx/img/flow-chart-pc.png";
import { bannerPosterImg, FOOTER_CONTENT, SEO } from "@/constants/wxHomepage";
import { WxBanner } from "../../components/wx-banner";
import { Footer } from "@/components";
import { WxOurInfomation } from "../../components/our-infomation";
import { HorizontalCards } from "../../components/horizontal-cards";
import { genBlock } from "@/utils/bem";
import { isWap } from "@/utils/tools";
import "./index.less";

const HORIZONTAL_CARD = [
  {
    img: require("@/assets/images/wx/img/28@3x.png"),
    title: "积分规则设置",
    desc: (
      <span>
        可设置推广上限以及粉丝获取积分上限
        <br />
        防止用户薅羊毛
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/29@3x.png"),
    title: "多类型积分兑换",
    desc: <span>可创建积分商品，也可选择兑换红包</span>,
  },
  {
    img: require("@/assets/images/wx/img/30@3x.png"),
    title: "多种发布方式",
    desc: (
      <span>
        可通过自定义菜单、关键词自动回复
        <br />
        等方式发布裂变海报
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/31@3x.png"),
    title: "数据统计",
    desc: (
      <span>
        统计生成卡片数、扫码关注人数、积分总数
        <br />
        折线统计图，观测数据更直观
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/32@3x.png"),
    title: "精确的地域限制",
    desc: (
      <span>
        实时GPS定位
        <br />
        防止用户更改地址钻漏洞
      </span>
    ),
  },
  {
    img: require("@/assets/images/wx/img/27@3x.png"),
    title: "自定义海报样式",
    desc: <span>可随意上传图片生成裂变海报</span>,
  },
];

const block = genBlock("wx-poster");

const WxPoster: React.FC<{}> = () => {

  React.useEffect(() => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', SEO.poster.keyword);
    document.querySelector('meta[name="description"]').setAttribute('content', SEO.poster.description);
  }, [])

  return (
    <div className={block()}>
      <WxBanner
        img={bannerPosterImg}
        btnText="立即使用"
        btnClick={isWap() ? null : "/v3/weixin/list"}
        className={block('banner')}
      />
      <HorizontalCards cards={HORIZONTAL_CARD} title="功能特点" />
      <img src={FlowChartWapImg} alt="" className={block("flow-chart-wap")} />
      <img src={FlowChartPcImg} alt="" className={block("flow-chart-pc")} />
      <WxOurInfomation />
      <Footer {...FOOTER_CONTENT} />
    </div>
  );
};

export default WxPoster;
